import React, { FC, lazy } from 'react';
import { Route, Routes as SwitchRoutes } from 'react-router-dom';
import { Routes } from 'constants/route.constants';
import { useUpdateUserRole } from 'common/hooks/useUpdateUserRole';
import ClientRoutes from 'routes/ClientRoutes/ClientRoutes';
import MemberPortalRoutes from 'routes/MemberRoutes/MemberRoutes';
import BookingShared from 'modules/booking/containers/BookingShared/BookingShared';

const CatchAllRoute = lazy(() => import('./CatchAll'));

const PrivateRotes: FC = () => {
  const userRole = useUpdateUserRole();
  const isClientPortal = userRole === 'client';
  const isMemberPortal = userRole === 'member';

  if (!isClientPortal && !isMemberPortal) {
    return null;
  }

  return (
    <SwitchRoutes>
      <Route path={Routes.BOOKING_SHARED} element={<BookingShared />} />
      <Route path="/commerceHubIFrame.html" />
      <Route path="/ITransactIFrame.html" />
      {isClientPortal && <Route path="/*" element={<ClientRoutes />} />}
      {isMemberPortal && <Route path="/*" element={<MemberPortalRoutes />} />}
      <Route path="*" element={<CatchAllRoute />} />
    </SwitchRoutes>
  );
};

export default PrivateRotes;
